import { Application } from "@rms-types/modules/application/entities/application";

const index = "application";

const getOneApplication = (applicationId: Application["id"]) => `${index}/${applicationId}`;
const getApplicationNotes = (applicationId: Application["id"]) => `${getOneApplication(applicationId)}/note`;
const getApplicationDisclosures = (applicationId: Application["id"]) =>
  `${getOneApplication(applicationId)}/disclosures`;
const getApplicationDocuments = (applicationId: Application["id"]) => `${getOneApplication(applicationId)}/document`;
const getApplicationUpdateStatus = (applicationId: Application["id"]) => `${getOneApplication(applicationId)}/status`;
const getApplicationUpdateDueDate = (applicationId: Application["id"]) =>
  `${getOneApplication(applicationId)}/due-date`;
const getApplicationUpdatePrimaryApplicant = (applicationId: Application["id"]) =>
  `${getOneApplication(applicationId)}/primary-applicant`;

const applicationReviewCount = `${index}/application-review-count`;

export const applicationEndpoint = Object.freeze({
  application: index,
  getOneApplication,
  getApplicationNotes,
  getApplicationDocuments,
  getApplicationDisclosures,
  getApplicationUpdateStatus,
  getApplicationUpdateDueDate,
  getApplicationUpdatePrimaryApplicant,

  applicationReviewCount,
  applicationSidebar: `${index}/application-sidebar`,
});
